module.exports = __webpack_public_path__ + "static/media/error-img.5e3719ba.svg";